// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchOnboardingOverhaul-cls1_mRr","cls2":"SearchOnboardingOverhaul-cls2_QeV SearchOnboardingOverhaul-cls1_mRr"};